// Host / capability abstraction. Detects the runtime host ONCE and exposes a
// single `host` object. Two hosts ship: the browser, and the Capacitor native
// apps. Electron was the third and is gone.
import browserHost from './browserHost';
import capacitorHost from './capacitorHost';

export function detectHostType(win) {
    if (win?.Capacitor?.isNativePlatform?.()) return 'capacitor';
    return 'browser';
}

const ADAPTERS = { capacitor: capacitorHost, browser: browserHost };

function buildHost(type) {
    return { type, ...ADAPTERS[type].caps };
}

const host = buildHost(detectHostType(typeof window !== 'undefined' ? window : undefined));

export default host;
